import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=6406dbd4&scoped=true&"
import script from "./jurisdiction.vue?vue&type=script&lang=ts&"
export * from "./jurisdiction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406dbd4",
  null
  
)

export default component.exports